const vhUnit = () => {
    document.documentElement.style.setProperty(
        '--vh',
        `${window.innerHeight * 0.01}px`
    );
};

export default vhUnit;

export const headerHeightVar = () => {
    document.documentElement.style.setProperty(
        '--headerHeight',
        `${
            document.querySelector('.main-header').getBoundingClientRect()
                .height
        }px`
    );
};

export const vhUnitMobileResize = () => {
    document.documentElement.style.setProperty(
        '--vhMobileResize',
        `${window.innerHeight * 0.01}px`
    );
};
